import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Modal, Input, Form, InputNumber, Radio } from "antd";
import { ToastContainer, toast } from "react-toastify";

const ShiftForm = ({ visible, onCancel, onAddOrUpdate, initialValues }) => {
  const { control, handleSubmit, reset } = useForm();
  const [initialValuesWithTimeConversion, setinitialValuesWithTimeConversion] =
    useState({});
  const [form] = Form.useForm();
  const shiftOTEnable = Form.useWatch('shiftOTEnable', form);


  const handleCancel = () => {
    onCancel();
  };

  const calculateShiftDuration = (shiftStartTime, shiftEndTime) => {
    const milliseconds_in_a_day = 24 * 60 * 60 * 1000;
    let shiftDuration;

    if (shiftStartTime <= shiftEndTime) {
      shiftDuration = shiftEndTime - shiftStartTime;
    } else {
      shiftDuration = milliseconds_in_a_day - shiftStartTime + shiftEndTime;
    }

    return shiftDuration;
  };
  const onFinishFailed = ({ errorFields }) => {
    errorFields.forEach((field) => {
      toast.error(
        `Please fill in the ${field.name.join(" ").toLowerCase()} field.`
      );
    });
  };
  const handleOk = async () => {
    try {
      await form.validateFields(); // Validate form fields
      const values = form.getFieldsValue(); // Get form values

      let isError = false;

      // Validate each required field
      const requiredFields = [
        "shiftFullName",
        "shiftShortName",
        "shiftStartTimeHours",
        "shiftStartTimeMinutes",
        "shiftEndTimeHours",
        "shiftEndTimeMinutes",
        "shiftLateEarlyTimeMinutes",

        "shiftHDLimitsStartHours",
        "shiftHDLimitsStartMinutes",
        "shiftHDLimitsEndHours",
        "shiftHDLimitsEndMinutes",
        "shiftMinWorkingHrsHours",
        "shiftMinWorkingHrsMinutes",
        "shiftLessTimeAfterHours",
        "shiftLessTimeAfterMinutes",
        // 'shiftMarkOTAfterHours',
        // 'shiftMarkOTAfterMinutes',
      ];

      requiredFields.forEach((fieldName) => {
        if (!values[fieldName] && values[fieldName] !== 0) {
          toast.error(
            `Please fill in the ${fieldName
              .replace(/([A-Z])/g, " $1")
              .toLowerCase()} field.`
          );
          isError = true;
        }
      });
      if (values.shiftOTEnable == false || values.shiftOTEnable == true) {
      } else {
        toast.error(`Please fill in the Shift OT Enable field.`);
        isError = true;
      }

      if (isError) {
        return;
      }
      Object.keys(values).forEach((key) => {
        if (key.endsWith("Hours") || key.endsWith("Minutes")) {
          values[key] = values[key] !== null ? parseInt(values[key], 10) : 0;
        }
      });

      const shiftStartTimeAMPM = values.shiftStartTimeAMPM || "AM"; // Default to AM if not selected
      const shiftStartTimeHours =
        shiftStartTimeAMPM === "PM"
          ? values.shiftStartTimeHours + 12
          : values.shiftStartTimeHours;
      const shiftStartTime = calculateMilliseconds(
        shiftStartTimeHours,
        values.shiftStartTimeMinutes,
        shiftStartTimeAMPM
      );

      const shiftEndTimeAMPM = values.shiftEndTimeAMPM || "AM";
      const shiftEndTimeHours =
        shiftEndTimeAMPM === "PM"
          ? values.shiftEndTimeHours + 12
          : values.shiftEndTimeHours;
      const shiftEndTime = calculateMilliseconds(
        shiftEndTimeHours,
        values.shiftEndTimeMinutes,
        shiftEndTimeAMPM
      );

      const shiftLateEarlyTime = calculateMinutesMilliseconds(
        values.shiftLateEarlyTimeMinutes
      );
      const shiftHDLimitsStart = calculateMilliseconds(
        values.shiftHDLimitsStartHours,
        values.shiftHDLimitsStartMinutes
      );
      const shiftHDLimitsEnd = calculateMilliseconds(
        values.shiftHDLimitsEndHours,
        values.shiftHDLimitsEndMinutes
      );
      const shiftMinWorkingHrs = calculateMilliseconds(
        values.shiftMinWorkingHrsHours,
        values.shiftMinWorkingHrsMinutes
      );
      const shiftLessTimeAfter = calculateMilliseconds(
        values.shiftLessTimeAfterHours,
        values.shiftLessTimeAfterMinutes
      );
      const shiftMarkOTAfter = calculateMilliseconds(
        values.shiftMarkOTAfterHours,
        values.shiftMarkOTAfterMinutes
      );

      const convertedValues = {
        shiftFullName: values.shiftFullName,
        shiftShortName: values.shiftShortName,
        shiftDescription: values.shiftDescription,
        shiftOTEnable: values.shiftOTEnable,
        shiftLateEarlyTime,
        shiftStartTime,
        shiftEndTime,
        shiftHDLimitsStart,
        shiftHDLimitsEnd,
        shiftMinWorkingHrs,
        shiftLessTimeAfter,
        shiftMarkOTAfter,
      };

      const shiftHrs = calculateShiftDuration(shiftStartTime, shiftEndTime);
      if (shiftEndTime == shiftStartTime) {
        toast.error("Shift End Time should not be equal to Shift End Time", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      if (shiftHrs < shiftHDLimitsStart) {
        toast.error("Shift HD Limits Start should be less than Shift Time", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      if (shiftHrs < shiftHDLimitsEnd) {
        toast.error("Shift HD Limits End should be less than Shift Time", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      if (shiftHDLimitsStart > shiftHDLimitsEnd) {
        toast.error(
          "Shift HD Limits Start should be less than Shift HD Limits End",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        return;
      }
      if (shiftHrs < shiftMinWorkingHrs) {
        toast.error("Shift Min Working Hrs should be less than Shift Time", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      if (shiftHrs < shiftLessTimeAfter) {
        toast.error("Shift Less Time After should be less than Shift Time", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      if (convertedValues && convertedValues.shiftOTEnable === false) {
        convertedValues.shiftMarkOTAfter = 0;
      }
      if (initialValues) {
        convertedValues["shiftId"] = initialValues?.shiftId;

        onAddOrUpdate(convertedValues);
        form.setFieldsValue(null);
      } else {
        onAddOrUpdate(convertedValues);
        form.setFieldsValue(null);
      }
    } catch (error) {
      console.error("Error validating fields:", error);
    }
  };
  const calculateMilliseconds = (hours, minutes, ampm) => {
    // if (hours !== null && minutes !== null) {
    //   return hours * 3600000 + minutes * 60000;
    // }
    // return null;
    if (hours !== null && minutes !== null && ampm !== null) {
      let totalMilliseconds = (hours % 12) * 3600000 + minutes * 60000; // Convert hours to 12-hour format
      if (ampm === "PM") {
        totalMilliseconds += 12 * 3600000; // Add 12 hours if PM
      } else if (ampm === "AM") {
        totalMilliseconds += 12 * 0; // Add 12 hours if PM
      }
      return totalMilliseconds;
    }
    return null;
  };
  const calculateMinutesMilliseconds = (minutes) => {
    if (minutes !== null) {
      return minutes * 60000;
    }
    return null;
  };

  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form.resetFields();
    } else {
      const convertedValues = convertTimeFieldsToFormat(initialValues);
      form.setFieldsValue(convertedValues);
    }
  }, [initialValues, form, visible]);
  const convertTimeFieldsToFormat = (initialValues) => {
    if (!initialValues) return {};

    const convertedValues = { ...initialValues };
    const timeRelatedFields = [
      "shiftStartTime",
      "shiftEndTime",
      "shiftLateEarlyTime",
      "shiftHDLimitsStart",
      "shiftHDLimitsEnd",
      "shiftMinWorkingHrs",
      "shiftLessTimeAfter",
      "shiftMarkOTAfter",
    ];

    Object.keys(convertedValues).forEach((key) => {
      if (timeRelatedFields.includes(key)) {
        const milliseconds = convertedValues[key];
        let hours, minutes, ampm;

        if (key === "shiftStartTime" || key === "shiftEndTime") {
          // Handle 12-hour format for shiftStartTime and shiftEndTime
          hours = Math.floor(milliseconds / 3600000) % 12;
          if (hours === 12) hours = 0; // Set hours to 12 if it's 0
          minutes = Math.floor((milliseconds % 3600000) / 60000);
          ampm = Math.floor(milliseconds / 3600000) < 12 ? "AM" : "PM";
        } else {
          // Keep the existing calculation for other time-related fields
          hours = Math.floor(milliseconds / 3600000);
          minutes = Math.floor((milliseconds % 3600000) / 60000);
          ampm = ""; // You may want to set AM/PM for other fields if needed
        }

        // Update the form fields for specific time fields
        convertedValues[`${key}Hours`] = hours;
        convertedValues[`${key}Minutes`] = minutes;
        convertedValues[`${key}AMPM`] = ampm;
      }
    });

    return convertedValues;
  };

  const validateTimeUnit = (rule, value, callback, unit) => {
    if (value !== null) {
      const isValid = Number.isInteger(value) && value >= 0 && value < unit;
      if (!isValid) {
        callback(`Please enter a valid ${unit}`);
      }
    }
    callback();
  };

  return (
    <Modal
      title="Add Shift"
      open={visible}
      className="ShiftModal"
      okButtonProps={{ style: { background: "grey" } }}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
    >
      <Form
        form={form}
        onFinishFailed={onFinishFailed}
        initialValues={initialValuesWithTimeConversion || undefined}
      >
        <div className="bg-[#EDF3FD] rounded-xl px-3 py-2">
          <div className="block">
            <Form.Item
              className="mb-2 [&_label]:mb-0"
              label={
                <span>
                  Shift Name <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="shiftFullName"
            >
              <Input className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none" />
            </Form.Item>
            <Form.Item
              className="mb-2 [&_label]:mb-0"
              label={
                <span>
                  Short Name <span style={{ color: "red" }}>*</span> (Maximum 5
                  letters are allowed)
                </span>
              }
              name="shiftShortName"
            >
              <Input
                maxLength={5}
                className="!h-12 bg-[#CDDEF9] rounded-full !px-5 w-full border-none"
              />
            </Form.Item>
            <Form.Item
              className="mb-2 [&_label]:mb-0"
              label={<span>Description </span>}
              name="shiftDescription"
            >
              <Input.TextArea className="!h-[100px] bg-[#CDDEF9] rounded-xl !px-5 py-2 w-full border-none" />
            </Form.Item>

            <Form.Item
              label="Shift Start Time"
              className="mb-2 [&_label]:mb-0"
              name="shiftStartTime"
            >
              <Input.Group
                compact
                className="!grid grid-flow-col gap-2 before:!hidden after:!hidden"
              >
                <Form.Item
                  className="flex-1 my-0"
                  name="shiftStartTimeHours"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 13),
                    },
                  ]}
                >
                  <InputNumber
                    className="w-100 bg-[#CDDEF9] rounded-full placeholder:text-[13px] border-none !shadow-none px-2 h-10 py-1 overflow-hidden"
                    placeholder="Hours"
                    min={1}
                    max={12}
                    formatter={(value) =>
                      value ? `${value}`.padStart(2, "0") : ""
                    }
                    parser={(value) => value.replace(/\D/g, "")}
                  />
                </Form.Item>
                <Form.Item
                  className="flex-1 my-0"
                  name="shiftStartTimeMinutes"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 60),
                    },
                  ]}
                >
                  <InputNumber
                    className="w-100 bg-[#CDDEF9] rounded-full placeholder:text-[13px] border-none !shadow-none px-2 h-10 py-1 overflow-hidden"
                    placeholder="Minutes"
                    min={0}
                    max={59}
                    formatter={(value) =>
                      value ? `${value}`.padStart(2, "0") : ""
                    }
                    parser={(value) => value.replace(/\D/g, "")}
                  />
                </Form.Item>
                <div className="ampmtab HourMinMain m-0">
                  <Form.Item
                    // label=""
                    className="flex-1 my-0 [&_label]:mb-0"
                    name="shiftStartTimeAMPM"
                  >
                    <Radio.Group className="filterRadio grid grid-flow-col !p-0 gap-2">
                      <Radio.Button
                        value="AM"
                        className="!h-[40px] !text-sm inline-flex items-center justify-center rounded-md overflow-hidden"
                      >
                        <span className="font-sbold">AM</span>
                      </Radio.Button>
                      <Radio.Button
                        value="PM"
                        className="!h-[40px] !text-sm inline-flex items-center justify-center rounded-md overflow-hidden"
                      >
                        <span className="font-sbold">PM</span>
                      </Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </Input.Group>
            </Form.Item>
            <Form.Item
              label="Shift End Time"
              className="mb-2 [&_label]:mb-0"
              name="shiftEndTime"
            >
              <Input.Group
                compact
                className="!grid grid-flow-col gap-2 before:!hidden after:!hidden"
              >
                <Form.Item
                  className="flex-1 my-0"
                  name="shiftEndTimeHours"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 13),
                    },
                  ]}
                >
                  <InputNumber
                    className="w-100 bg-[#CDDEF9] rounded-full placeholder:text-[13px] border-none !shadow-none px-2 h-10 py-1 overflow-hidden"
                    placeholder="Hours"
                    min={1}
                    max={12}
                    formatter={(value) =>
                      value ? `${value}`.padStart(2, "0") : ""
                    }
                    parser={(value) => value.replace(/\D/g, "")}
                  />
                </Form.Item>
                <Form.Item
                  className="flex-1 my-0 [&_label]:mb-0"
                  name="shiftEndTimeMinutes"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 60),
                    },
                  ]}
                >
                  <InputNumber
                    className="w-100 bg-[#CDDEF9] rounded-full placeholder:text-[13px] border-none !shadow-none px-2 h-10 py-1 overflow-hidden"
                    placeholder="Minutes"
                    min={0}
                    max={59}
                    formatter={(value) =>
                      value ? `${value}`.padStart(2, "0") : ""
                    }
                    parser={(value) => value.replace(/\D/g, "")}
                  />
                </Form.Item>
                <div className="ampmtab HourMinMain my-0">
                  <Form.Item className="flex-1 my-0 [&_label]:mb-0" name="shiftEndTimeAMPM">
                    <Radio.Group className="filterRadio grid grid-flow-col saurabh !p-0 gap-2">
                      <Radio.Button
                        value="AM"
                        className="!h-[40px] !text-sm inline-flex items-center justify-center rounded-md overflow-hidden"
                      >
                        <span className="font-sbold">AM</span>
                      </Radio.Button>
                      <Radio.Button
                        value="PM"
                        className="!h-[40px] !text-sm inline-flex items-center justify-center rounded-md overflow-hidden"
                      >
                        <span className="font-sbold">PM</span>
                      </Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </Input.Group>
            </Form.Item>

            <Form.Item
              className="mb-2 [&_label]:mb-0"
              label={
                <span>
                  Shift Late/Early Time (in minutes){" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="shiftLateEarlyTime"
            >
              <Form.Item
                className="HourMinMain px-0 !shadow-none"
                name="shiftLateEarlyTimeMinutes"
                rules={[
                  {
                    validator: (rule, value, callback) =>
                      validateTimeUnit(rule, value, callback, 60),
                  },
                ]}
              >
                <InputNumber
                  className="!h-10 bg-[#CDDEF9] rounded-full !px-2 w-full py-[4px] !border-none !shadow-none"
                  placeholder="Minutes"
                  min={0}
                  max={59}
                />
              </Form.Item>
            </Form.Item>
            <Form.Item
              className=" [&_label]:mb-0"
              label={
                <span>
                  Enable Shift OT <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="shiftOTEnable"
            >
              <Radio.Group
                onChange={(e) =>
                  form.setFieldsValue({ shiftOTEnable: e.target.value })
                }
              >
                <Radio value={true}>True</Radio>
                <Radio value={false}>False</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              className="mb-2 [&_label]:mb-0"
              label={
                <span>
                  Shift HD Limits Start <span style={{ color: "red" }}>*</span>
                </span>
              }
            >
              <Input.Group
                compact
                className="!grid grid-flow-col gap-2 before:!hidden after:!hidden"
              >
                <Form.Item
                  className="HourMinMain flex-1 w-auto m-0"
                  name="shiftHDLimitsStartHours"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 24),
                    },
                  ]}
                >
                  <InputNumber
                    className="h-10 w-full bg-[#CDDEF9] rounded-full  placeholder:text-[13px] !outline-none !border-none !shdaow-none !px-2 py-1 overflow-hidden"
                    placeholder="Hours"
                    min={0}
                    max={23}
                  />
                </Form.Item>
                <Form.Item
                  className="HourMinMain flex-1 w-auto m-0"
                  name="shiftHDLimitsStartMinutes"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 60),
                    },
                  ]}
                >
                  <InputNumber
                    className="h-10 w-full bg-[#CDDEF9] rounded-full  placeholder:text-[13px] !outline-none !border-none !shdaow-none !px-2 py-1 overflow-hidden"
                    placeholder="Minutes"
                    min={0}
                    max={59}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item
              className="mb-2 [&_label]:mb-0"
              label={
                <span>
                  Shift HD Limits End <span style={{ color: "red" }}>*</span>
                </span>
              }
            >
              <Input.Group
                compact
                className="!grid grid-flow-col gap-2 before:!hidden after:!hidden"
              >
                <Form.Item
                  className="HourMinMain flex-1 w-auto m-0"
                  name="shiftHDLimitsEndHours"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 24),
                    },
                  ]}
                >
                  <InputNumber
                    className="h-10 w-full bg-[#CDDEF9] rounded-full  placeholder:text-[13px] !outline-none !border-none !shdaow-none !px-2 py-1 overflow-hidden"
                    placeholder="Hours"
                    min={0}
                    max={23}
                  />
                </Form.Item>
                <Form.Item
                  className="HourMinMain flex-1 w-auto m-0"
                  name="shiftHDLimitsEndMinutes"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 60),
                    },
                  ]}
                >
                  <InputNumber
                    className="h-10 w-full bg-[#CDDEF9] rounded-full  placeholder:text-[13px] !outline-none !border-none !shdaow-none !px-2 py-1 overflow-hidden"
                    placeholder="Minutes"
                    min={0}
                    max={59}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item
              className="mb-2 [&_label]:mb-0"
              label={
                <span>
                  Shift Min Working Hrs (Below this time the person will be
                  marked absent) <span style={{ color: "red" }}>*</span>
                </span>
              }
            >
              <Input.Group
                compact
                className="!grid grid-flow-col gap-2 before:!hidden after:!hidden"
              >
                <Form.Item
                  className="HourMinMain flex-1 w-auto m-0"
                  name="shiftMinWorkingHrsHours"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 24),
                    },
                  ]}
                >
                  <InputNumber
                    className="h-10 w-full bg-[#CDDEF9] rounded-full  placeholder:text-[13px] !outline-none !border-none !shdaow-none !px-2 py-1 overflow-hidden"
                    placeholder="Hours"
                    min={0}
                    max={23}
                  />
                </Form.Item>
                <Form.Item
                  className="HourMinMain flex-1 w-auto m-0"
                  name="shiftMinWorkingHrsMinutes"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 60),
                    },
                  ]}
                >
                  <InputNumber
                    className="h-10 w-full bg-[#CDDEF9] rounded-full  placeholder:text-[13px] !outline-none !border-none !shdaow-none !px-2 py-1 overflow-hidden"
                    placeholder="Minutes"
                    min={0}
                    max={59}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item
              className="mb-2 [&_label]:mb-0"
              label={
                <span>
                  Shift Less Time After (Below this time person will be less
                  time) <span style={{ color: "red" }}>*</span>
                </span>
              }
            >
              <Input.Group
                compact
                className="!grid grid-flow-col gap-2 before:!hidden after:!hidden"
              >
                <Form.Item
                  className="HourMinMain flex-1 w-auto m-0"
                  name="shiftLessTimeAfterHours"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 24),
                    },
                  ]}
                >
                  <InputNumber
                    className="h-10 w-full bg-[#CDDEF9] rounded-full  placeholder:text-[13px] !outline-none !border-none !shdaow-none !px-2 py-1 overflow-hidden"
                    placeholder="Hours"
                    min={0}
                    max={23}
                  />
                </Form.Item>
                <Form.Item
                  className="HourMinMain flex-1 w-auto m-0"
                  name="shiftLessTimeAfterMinutes"
                  rules={[
                    {
                      validator: (rule, value, callback) =>
                        validateTimeUnit(rule, value, callback, 60),
                    },
                  ]}
                >
                  <InputNumber
                    className="h-10 w-full bg-[#CDDEF9] rounded-full  placeholder:text-[13px] !outline-none !border-none !shdaow-none !px-2 py-1 overflow-hidden"
                    placeholder="Minutes"
                    min={0}
                    max={59}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>
            {form.getFieldValue("shiftOTEnable") &&
              form.getFieldValue("shiftOTEnable") === true && (
                <>
                  <Form.Item
                    className="mb-2 [&_label]:mb-0"
                    label={
                      <span>
                        Shift Mark OT After{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                  >
                    <Input.Group
                      compact
                      className="!grid grid-flow-col gap-2 before:!hidden after:!hidden"
                    >
                      <Form.Item
                        className="HourMinMain flex-1 w-auto m-0"
                        name="shiftMarkOTAfterHours"
                        rules={[
                          {
                            validator: (rule, value, callback) =>
                              validateTimeUnit(rule, value, callback, 24),
                          },
                        ]}
                      >
                        <InputNumber
                          className=" staffAttendForm h-10 w-100 bg-[#CDDEF9] rounded-full  placeholder:text-[13px] outline-none overflow-hidden"
                          placeholder="Hours"
                          min={0}
                          max={23}
                        />
                      </Form.Item>
                      <Form.Item
                        className="HourMinMain flex-1 w-auto m-0"
                        name="shiftMarkOTAfterMinutes"
                        rules={[
                          {
                            validator: (rule, value, callback) =>
                              validateTimeUnit(rule, value, callback, 60),
                          },
                        ]}
                      >
                        <InputNumber
                          className=" h-10 w-100 bg-[#CDDEF9] rounded-full  placeholder:text-[13px] outline-none overflow-hidden"
                          placeholder="Minutes"
                          min={0}
                          max={59}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </>
              )}
          </div>
        </div>

        <div className="text-center mt-4">
          <Button
            className="!border-[#6198ED] bg-[#6198ED] text-[#ffffff] hover:bg-[#ffffff] hover:!text-[#6198ED] rounded-full py-2 px-5 h-auto !text-sm"
            onClick={handleOk}
          >
            <span className="font-sbold">+Add Shift</span>
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ShiftForm;
